export const getters = {
  getUsers(state) {
    return state.users;
  }
}
